import Utils from "../utils/Utils.js"
import cookie from 'js-cookie'
import * as config from '../utils/Config.js'
let socket = null

const loadScript = new Promise((resolve) => {
  Utils.loadSocket().then(() => {
    resolve(window.io)
  })
})

const start = async () => {
  const io = window.io || await Promise.resolve(loadScript)
  // const token = sessionStorage.getItem(config.userTokenKey)
  const token = cookie.get(config.userTokenKey)
  const url = Utils.generateSocketUrl()
  const env = process.env.NODE_ENV
  // if (socket) {
  //   socket.disconnect()
  //   socket = null
  // }

  return new Promise((resolve, reject) => {
    resolve({
      on: () => {}
    })
    
    return

    if (socket) {
      resolve(socket)
      
      return
    }

    if (!token) {
      reject(new Error('获取token失败'))
      
      return
    }
    // 开发环境指定
    if (env.includes('dev')) {
      socket = socket || io(url, { transports: ['websocket'], query: { token } })
    } else {
      socket = socket || io({ transports: ['websocket'], query: { token } })
    }

    socket.on('connect', () => {
      console.log(`socket ${socket.id} 连接成功`)
      socket.emit('init')
      resolve(socket)
    })

    socket.on('reconnect_attempt', async () => {
      // const token = sessionStorage.getItem(config.userTokenKey)
      const token = cookie.get(config.userTokenKey)
      console.log(`重连: token: ${socket.io.opts.query.token}, new token: ${token}`)
      if (token) {
        await Utils.refreshToken()
      }
      
      socket.io.opts.query.token = token
    })

    socket.on('reconnect', () => {
      console.log('重连成功')
    })

    socket.on("disconnect", () => {
      // console.log(`${socket.id} 断开连接`)
      // Utils.refreshToken()
    })

    socket.on('connect_error', () => {
      reject(new Error('socket连接失败'))
    })
  }).catch((error) => {
    if (error) {
      // 异常处理
      console.log('socket连接失败')
    }
  })
}


export { start }